import Config from './Config';
import { MakeApiCallAsync } from './ApiHelpers';
import { resolvePromotionUrl } from './PromotionLinks';

export async function loadPromotionUrls(campaigns, language) {
    const searchProducts = async term => {
        const response = await MakeApiCallAsync(Config.END_POINT_NAMES.GET_All_PRODUCTS, null,
            { requestParameters: { SearchTerm: term, SizeID: null, ColorID: null, CategoryID: null,
                TagID: null, ManufacturerID: null, MinPrice: null, MaxPrice: null, Rating: null,
                OrderByColumnName: '', PageNo: 1, PageSize: 100, recordValueJson: '[]' } },
            { Accept: 'application/json', 'Content-Type': 'application/json' }, 'POST', true);
        if (!response?.data?.data) return [];
        const results = JSON.parse(response.data.data);
        return Array.isArray(results) ? results : [];
    };
    return Promise.all(campaigns.map(campaign => resolvePromotionUrl(campaign, language, searchProducts)));
}
